import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const ObservacionesModal = ({ toggle, isOpen, observaciones }) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ width: "400px" }}>
        <ModalHeader toggle={toggle} className="border-0 pb-0" />
        <ModalBody className="pt-1" style={{ alignItems: "flex-start !important", fontFamily: "Nunito" }}>
          <h6 style={{ fontWeight: "bold", fontSize: "14px", alignSelf: "flex-start" }}>Comentarios:</h6>
          <p>{observaciones}</p>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ObservacionesModal;
